import { Box } from '@looker/components';
import { globalTheme } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const StyledPromptContainer = styled(Box)`
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${globalTheme.colors.outlineLight};
  background: ${globalTheme.colors.backgroundLight}
`;

export const StyledTextArea = styled.textarea`
  width: 100%;
  max-height: 400px;
  overflow: auto;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  font-family: ${globalTheme.fonts.plainText.fontFamily};
  font-size: ${globalTheme.fonts.plainText.fontSize};
  font-weight: ${globalTheme.fonts.plainText.fontWeight}
  line-height: ${globalTheme.fonts.plainText.lineHeight}
  letter-spacing: ${globalTheme.fonts.plainText.letterSpacing};
`;
